import { defineMessages } from 'react-intl';

export default defineMessages({
    businessName: {
        id: 'ml.quoteandbind.businessPursuitsLiability.businessName',
        defaultMessage: 'Business Name'
    },
    insured: {
        id: 'ml.quoteandbind.businessPursuitsLiability.insured',
        defaultMessage: 'Insured'
    },
    occupation: {
        id: 'ml.quoteandbind.businessPursuitsLiability.occupation',
        defaultMessage: 'Occupation'
    },
    isInsuredSoleOwner: {
        id: 'ml.quoteandbind.businessPursuitsLiability.isInsuredSoleOwner',
        defaultMessage: 'Is insured the sole owner or a partner of the business?'
    },
    action: {
        id: 'ml.quoteandbind.businessPursuitsLiability.action',
        defaultMessage: 'Action'
    },
    addBtn: {
        id: 'ml.quoteandbind.businessPursuitsLiability.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.businessPursuitsLiability.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.businessPursuitsLiability.remove',
        defaultMessage: 'Remove'
    }
});